exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".timesheet-timer {\n  display: flex;\n  border-bottom: 1px solid #839aa7;\n  width: 56rem;\n  margin: 4rem auto 0;\n  padding: 0 5rem 4.5rem;\n}\n\n.timesheet-timer .time {\n  font-size: 6rem;\n  display: flex;\n  align-items: center;\n  justify-content: flex-end;\n  flex-grow: 1;\n}\n\n.timesheet-timer .time.time-small {\n  font-size: 5rem;\n}\n\n.timesheet-timer .button {\n  width: 19.5rem;\n}\n\n.timesheet-timer .button>span {\n  display: flex;\n  justify-content: center;\n}\n\n.timesheet-timer .button>span>.icon {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding-right: 1rem;\n}\n\n", ""]);

// exports
